import Fuse from 'fuse.js';

export const filterIsSet = (userData) => !!Object.keys(userData.taxonomies).length;

export const isOptionDisabled = (taxonomyName, option, appData, userData) => {
	const taxonomies = { ...userData.taxonomies, [taxonomyName]: option.slug };
	return !(appData.jobs.filter((job) => jobMatchesTaxonomy(job, { ...userData, taxonomies })).length > 0);
};

export const getFilteredJobs = (appData, userData, currentlyVisibleJobs) => {
	let filteredJobs;

	if (!filterIsSet(userData)) {
		// If no filter is set, return all jobs that are in range of the visible jobs limit
		// If the limit is not set, return all jobs
		filteredJobs = currentlyVisibleJobs ? appData.jobs.slice(0, currentlyVisibleJobs) : appData.jobs;
	} else {
		// 1. Get all Jobs that match the taxonomy filters
		filteredJobs = appData.jobs.filter((job) => jobMatchesTaxonomy(job, userData));

		// 2. If a search query is set, filter the jobs by the search query
		if (filteredJobs.length && userData.taxonomies?.q) {
			const searchTerm = userData.taxonomies.q;
			const fuse = new Fuse(filteredJobs, {
				keys: ['title', 'excerpt'],
				includeScore: true,
				ignoreLocation: true,
			});
			const searchResults = fuse.search(searchTerm);

			filteredJobs = searchResults.filter((result) => result.score <= 0.5).map((result) => result.item);
		}
	}

	return filteredJobs;
};

const jobMatchesTaxonomy = (job, userData) => {
	// Check if job matches all taxonomy filters
	for (const [taxonomyName, taxonomyValue] of Object.entries(userData.taxonomies)) {
		if ('q' === taxonomyName) {
			continue;
		}

		// Return false if not at least one term of the job matches the filtered taxonomy term
		if (!job.taxonomies[taxonomyName].some((term) => term === taxonomyValue)) {
			return false;
		}
	}

	return true;
};
